export const CONTACT = {
  whatsappNumber: '918698761333',
  whatsappDisplay: '+91 86987 61333',
  email: 'enterprise@AeroBott.in',
};

export const buildWhatsAppUrl = (text: string): string =>
  `https://wa.me/${CONTACT.whatsappNumber}?text=${encodeURIComponent(text)}`;
